import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { grantAnalyticsConsent, denyAnalyticsConsent } from '@/lib/analytics';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Small delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    grantAnalyticsConsent();
    setVisible(false);
  };

  const handleDecline = () => {
    denyAnalyticsConsent();
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[9999]"
        >
          <div className="rounded-xl border border-border bg-card/95 backdrop-blur-xl p-5 shadow-2xl">
            <div className="flex items-start gap-3 mb-3">
              <div className="p-2 rounded-lg bg-primary/10 shrink-0">
                <Cookie className="h-5 w-5 text-primary" />
              </div>
              <div>
                <h3 className="font-semibold text-foreground text-sm mb-1">
                  Cookie Consent
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  We use cookies and Google Analytics to understand how you use OpsGPT and improve your experience. 
                  No personal data is shared with third parties.
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2 mt-4">
              <Button
                variant="outline"
                size="sm"
                onClick={handleDecline}
                className="flex-1 text-xs"
              >
                Decline
              </Button>
              <Button
                size="sm"
                onClick={handleAccept}
                className="flex-1 text-xs"
              >
                <Shield className="h-3.5 w-3.5 mr-1.5" />
                Accept
              </Button>
            </div>

            <p className="text-[10px] text-muted-foreground mt-3 text-center">
              <a href="/privacy" className="underline hover:text-foreground transition-colors">
                Privacy Policy
              </a>
              {' · '}
              <a href="/terms" className="underline hover:text-foreground transition-colors">
                Terms of Service
              </a>
            </p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
